import React from "react";
import {
  Briefcase,
  Users,
  FileText,
  Search,
  Calendar,
  Award,
  BarChart,
  Building,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Job Portal Development",
    description:
      "Build job boards with advanced search and matching algorithms",
    icon: Search,
  },
  {
    title: "ATS Systems",
    description: "Develop applicant tracking systems for streamlined hiring",
    icon: FileText,
  },
  {
    title: "HR Management Platforms",
    description: "Comprehensive HRMS for employee lifecycle management",
    icon: Users,
  },
  {
    title: "Recruitment CRM",
    description: "Build recruiter tools for candidate relationship management",
    icon: Briefcase,
  },
  {
    title: "Employee Onboarding",
    description: "Digital onboarding workflows and documentation",
    icon: Building,
  },
  {
    title: "Performance Management",
    description: "Goal tracking, reviews, and feedback systems",
    icon: Award,
  },
  {
    title: "Workforce Analytics",
    description: "HR dashboards for insights and decision-making",
    icon: BarChart,
  },
  {
    title: "Scheduling & Attendance",
    description: "Time tracking and shift management solutions",
    icon: Calendar,
  },
];

const STATS = [
  { value: "10M+", label: "Job Applications" },
  { value: "50K+", label: "Companies" },
  { value: "500K+", label: "Hires Made" },
  { value: "60%", label: "Faster Hiring" },
];

const HRTechIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="jobs-hr-tech"
      industryTitle="Jobs"
      industrySubtitle="& HR Tech"
      heroDescription="Empowering organizations with innovative HR technology solutions, job portals, and recruitment platforms that attract talent and streamline human resource operations."
      themeColor="#7c3aed"
      themeColorLight="#a78bfa"
      themeGradient="linear-gradient(135deg, #4c1d95 0%, #5b21b6 50%, #7c3aed 100%)"
      HeroIcon={Briefcase}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1681398836231-d0b89bd571d6?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default HRTechIndustryPage;
